$("._tab").click(function() {
    let parentBlock = $(this).parents(".tabs-parent")
    let tabId = $(this).attr("data-tab")
    $(parentBlock).find("._tab").removeClass("_active")
    $(this).addClass("_active")
    $(parentBlock).find("._tab-content").removeClass("_active")
    $(parentBlock).find(`._tab-${tabId}`).addClass("_active")
})

$(document).on('click', '.qa-card__show', function(e) {
    $(this).parents(".qa-card").toggleClass("_active")
    $(this).siblings(".qa-card__hidden").slideToggle()
})

$('.video').click(function() {
    let video = $(this).find("video")
    if (video[0].paused) {
        video[0].play()
        $(this).addClass("_played")
    } else {
        video[0].pause()
        $(this).removeClass("_played")
    }
});

$(".pass-toggle").click(function() {
    let inputType = 'password'
    if ($(this).hasClass("_active")) {
        $(this).removeClass("_active")
        inputType = 'password'
    } else {
        $(this).addClass("_active")
        inputType = 'text'
    }
    $(this).siblings("input").attr("type", inputType)
})

$(".user__toggle").click(function () {
    $(".user").toggleClass("_active")
    if(window.innerWidth<=992){
        $("body").addClass("fixed-body")
    }
})

$("._close-menu").click(function () {
    $(".user").removeClass("_active")
    $("body").removeClass("fixed-body")
})

$(document).mouseup(function(e) {
    var div = $('.user');
    if (!div.is(e.target) && div.has(e.target).length === 0) {
        if($(div).hasClass("_active")){
            $(div).removeClass("_active")
        }
    }
});

